<template>
    <div style="overflow-y: auto;height: 100%;">
        <el-row>
            <el-col :span="24">
                <el-form :inline="true">
	                <el-form-item label="省:">
		                <el-select
				                @change="selectRowChange1"
				                v-model="filter.selecSheng"
				                ref ='provinceRef'
				                placeholder="请选择"
				                v-loading='provinceLoading'
				                clearable
		                >
			                <template v-for="item in shengArr">
				                <el-option
						                :key="item.Id"
						                :label="item.Name"
						                :value="item.Code"
				                >
				                </el-option>
			                </template>
		                </el-select>
	                </el-form-item>
	                <el-form-item label="市:">
		                <el-select
				                @change="selectRowChange2"
				                v-model="filter.selecShi"
				                placeholder="请选择"
				                ref ='cityRef'
				                v-loading='cityLoading'
				                clearable
		                >
			                <template v-for="item in shiArr">
				                <el-option
						                :key="item.Id"
						                :label="item.Name"
						                :value="item.Code"
				                >
				                </el-option>
			                </template>
		                </el-select>
	                </el-form-item>
	                <el-form-item label="区/县:">
		                <el-select
				                v-model="filter.selecXian"
				                placeholder="请选择"
				                ref ='regionRef'
				                v-loading='areaLoading'
				                clearable
		                >
			                <template v-for="item in xianArr">
				                <el-option
						                :key="item.Id"
						                :label="item.Name"
						                :value="item.Code"
				                >
				                </el-option>
			                </template>
		                </el-select>
	                </el-form-item>
                    <el-form-item label="关键字:">
                        <el-input v-model='filter.name' placeholder='请输入单位名称/姓名/手机号' clearable></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="取证状态:">
                        <el-select v-model="filter.ForensicStatus" placeholder="请选择取证状态" clearable>
                            <el-option
                                v-for="item in ForensicStatusArr"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="已通知次数:">
                        <el-select v-model="filter.Notified" placeholder="请选择已通知次数" multiple collapse-tags clearable>
                            <el-option
                                v-for="item in NotifiedArr"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="已发送短信模板:">
                        <el-select v-model="filter.NoteTem" placeholder="请选择已发送短信模板" multiple collapse-tags clearable>
                            <el-option
                                v-for="item in NoteTemArr"
                                :key="item.Id"
                                :label="item.Name"
                                :value="item.Id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type='primary' @click='search'>查询</el-button>
                        <el-button type='primary' @click='back'>返回</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-table
            :data="tableData"
            v-loading="tableLoading"
            border
            highlight-current-row
            style="width: 100%"
        >
            <el-table-column type='index' label="序号" width='60' align="center"></el-table-column>
            <!-- <el-table-column prop="Province" label="省" align="center"></el-table-column> -->
            <el-table-column prop="CityName" label="市" align="center"></el-table-column>
            <el-table-column prop="DistrictName" label="区/县" align="center"></el-table-column>
            <el-table-column prop="UnitName" label="单位名称" align="center"></el-table-column>
            <el-table-column prop="Name" label="姓名" align="center"></el-table-column>
            <el-table-column prop="PhoneNumber" label="手机号" align="center"></el-table-column>
            <!-- <el-table-column prop="Station" label="岗位" align="center"></el-table-column>
            <el-table-column prop="Trade" label="行业" align="center"></el-table-column> -->
            <!-- <el-table-column prop="NotifiedTimes" label="已通知次数" align="center"></el-table-column> -->
            <el-table-column prop="LastNotificationTime" label="最后通知时间" align="center"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.PageIndex"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pages.PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pages.DataCount"
            class='pageBar'
        >
        </el-pagination>
    </div>
</template>

<script>
import { getNoticeRecordDetailListPage,getAreaDictionaryList,listForSocialUnit,listForSocialUnitStaff,selectAllSmsTemplateName,getSocialGroupDetailListPage } from '@/api/api'
export default {
    data(){
        return {
	        shengArr:[],
	        shiArr: [],
	        xianArr: [],
	        provinceLoading:false,
	        listLoading3 : false,
	        listLoading4 : false,
	        cityLoading:false,
	        areaLoading:false,
	        jieLoading:false,
            buttonList:[],
            filter:{
                name: '',
	            selecSheng: undefined,
	            selecShi: '',
	            selecXian: '',
                ForensicStatus: '',
                Notified: [],
                NoteTem: [],
                hasPhone: null,
                parentID: null,
            },
            provinceArr: [],
            cityArr: [],
            countyArr: [],
            ForensicStatusArr:[{
                label:'未注册APP账号',value: "0-1"
            },{
                label:'考试未合格',value: "1-1"
            },{
                label:'证书数量0',value: 0
            },{
                label:'证书数量1',value: 1
            },{
                label:'证书数量2',value: 2
            },{
                label:'证书数量大于2',value: "2-1"
            }],
            NotifiedArr:[{
                label:'0',value: 0
            },{
                label:'1',value: 1
            },{
                label:'2',value: 2
            },{
                label:'3',value: 3
            },{
                label:'4',value: 4
            },{
                label:'5',value: 5
            },{
                label:'大于5',value: "0-1"
            }],
            NoteTemArr:[{
                label:'模板1',value:0
            },{
                label:'模板2',value:1
            }],
            tableData:[],
            tableLoading: false,
            pages:{
                PageIndex:1,
                PageSize:20,
                DataCount:0
            },
            id:null,
            hasSocialUnit: '',
            isSendSuccess: '',
        }
    },
    methods:{
	    // 省选中
	    selectRowChange1(row) {
		    if(!row){
			    this.shiArr = []
			    this.xianArr = []
			    this.filters.selecShi = ''
			    this.filters.selecXian = ''
		    }else{
			    this.parentSheng = row
			    const idSheng = this.shengArr.filter(item =>item.Code === this.filter.selecSheng)
			    // this.pages1Change2()
			    let params = {
				    parentId: idSheng[0].Id,
				    // level:1
			    }
			    this.getPlace(params,1)
		    }
	    },
	    // 市选中
	    selectRowChange2(row) {
		    if(!row){
			    this.xianArr = []
			    this.jieArr = []
			    this.filter.selecXian = ''
			    // this.addSocialFrom.selecXian = ''
			    // this.addSocialFrom.selecJie = ''
		    }else{
			    this.xianArr = []
			    this.jieArr = []
			    this.filter.selecXian = ''
			    const shiId = this.shiArr.filter(item =>item.Code === this.filter.selecShi)
			    // this.addSocialFrom.selecXian = ''
			    // this.addSocialFrom.selecJie = ''
			    this.parentShi = row
			    let params = {
				    parentId: shiId[0].Id,
				    // level: 2
			    }
			    this.getPlace(params,2)
		    }
	    },
	    // 区/县选中
	    selectRowChange3(row) {
		    if(!row){
			    this.jieArr = []
			    // this.addSocialFrom.selecJie = ''
		    }else{
			    this.jieArr = []
			    // this.addSocialFrom.selecXian = row
			    const xianId = this.xianArr.filter(item =>item.Code === this.filter.selecXian)
			    // this.addSocialFrom.selecJie = ''
			    let params = {
				    parentId: xianId[0].Id,
				    // level: 3
			    }
			    this.getPlace(params,3)
		    }
	    },
	    // 获取行政区域
	    getPlace(params,level){
		    switch(level){
			    case 0:
				    this.provinceLoading = true
				    break;
			    case 1:
				    this.cityLoading = true
				    break;
			    case 2:
				    this.areaLoading = true
				    break
			    case 3:
				    this.jieLoading = true
				    break
		    }
		    getAreaDictionaryList(params).then(res => {
			    if(res.data.Success){
				    switch(level){
					    case 0:
						    this.provinceLoading = false
						    this.shengArr = res.data.Response;
						    break;
					    case 1:
						    this.cityLoading = false
						    this.shiArr = res.data.Response;
						    break;
					    case 2:
						    this.areaLoading = false
						    this.xianArr = res.data.Response;
						    break
					    case 3:
						    this.jieLoading = false
						    if(res.data.Response && res.data.Response.length > 0) {
							    this.jieArr = res.data.Response;
						    } else {
							    var newObj = {
								    Name: '-',
								    ID: 0,
							    }
							    this.jieArr.unshift(newObj)
						    }
						    break
				    }
			    }else{return}
		    }).catch(() => {})
	    },
        // 查询
        search(){
            this.getData()
        },
        // 返回
        back(){
            this.$router.go(-1)
        },
        // 分页处理
        handleSizeChange(value){
            this.pages.PageSize = value
            this.getData()
        },
        handleCurrentChange(value){
            this.pages.PageIndex = value
            this.getData()
        },
        // 查询通知名单
        getData(){
            var params = {
                keyWord: this.filter.name,
                provinceCode: this.filter.selecSheng,
                cityCode: this.filter.selecShi,
	            districtCode: this.filter.selecXian,
                // certificateStatus: this.filter.ForensicStatus,
                noticeCount: this.filter.Notified.length > 0 ? this.filter.Notified.join(",") : null,
                noticeTemplateID: this.filter.NoteTem.length > 0 ? JSON.stringify(this.filter.NoteTem) : null,
                noticeManageRecordId: this.filter.parentID,
                // hasSocialUnit: this.hasSocialUnit,
                sendStatus: this.isSendSuccess, //此处应为发送短信成功/失败查询字段，现为是否有手机号查询
                pageIndex: this.pages.PageIndex,
                pageSize: this.pages.PageSize,
            }
            this.tableLoading = true
            // listForSocialUnit(params).then(res => {
            listForSocialUnitStaff(params).then(res => {
                var result = res.data
                if(result.Success){
                    this.tableData = result.Response.Data
                    this.pages.DataCount = result.Response.DataCount
                }else{
                    return
                }
                this.tableLoading = false
            })
        },
        GetAreaFun(e,i) {
            if(i == 0) {
                var params = {
                    Level: e,
                }
            } else {
                var params = {
                    parentId: e,
                }
            }
            getAreaDictionaryList(params).then(res => {
                var result = res.data
                if(result.Success) {
                    if(i == 0) {
                        this.provinceArr = result.Response.reverse()
                    } else if(i == 1) {
                        this.cityArr = result.Response.reverse()
                    } else if(i == 2) {
                        this.countyArr = result.Response.reverse()
                    }
                }
            })
        },
        getSmsTemplateNameFun() {
            selectAllSmsTemplateName().then(res => {
                var result = res.data
                if(result.Success) {
                    this.NoteTemArr = result.Response
                }
            })
        },
        // 时间格式化
        dateFormat(format,date){
            let ret = ''
            date = new Date(date)
            const option = {
                'Y+':date.getFullYear().toString(),  //
                'm+':(date.getMonth() + 1).toString(),
                'd+':date.getDate().toString(),
                'H+':date.getHours().toString(),
                'M+':date.getMinutes().toString(),
                'S+':date.getSeconds().toString()
            }
            for(let k in option){
                ret = new RegExp('('+k+')').exec(format)
                if(ret){
                    format = format.replace(
                        ret[1],
                        ret[1].length == 1? option[k] :option[k].padStart(ret[1].length,'0')
                    )
                }
            }
            return format
        }
    },
    created(){
        var hasPhone = this.$route.query.hasPhone
        var parentID = this.$route.query.ID
        this.isSendSuccess = this.$route.query.isSendSuccess
        this.hasSocialUnit = this.$route.query.hasSocialUnit
        if(hasPhone == 'null') {
            this.filter.hasPhone = null
        } else {
            this.filter.hasPhone = hasPhone
        }
        if(parentID == 'null') {
            this.filter.parentID = null
        } else {
            this.filter.parentID = parentID
        }
        this.getData()
        // this.GetAreaFun(0,0)
		    let params = {
			    parentId: 1,
			    // level: 1,
		    }
		    this.getPlace(params,0)
        this.getSmsTemplateNameFun()
    },
    mounted(){
        let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
    },
    watch: {
        'filter.province': function(val) {
            this.GetAreaFun(val,1)
            this.filter.city = ''
            this.filter.county = ''
        },
        'filter.city': function(val) {
            this.GetAreaFun(val,2)
            this.filter.county = ''
        }
    }
}
</script>

<style lang="stylus" scoped>
    // .pageBar{
    //     margin-top:15px!important;
    // }
</style>